module.exports = __webpack_public_path__ + "img/teaching-wolf.45692265.png";